(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

    // setTimeout(function(){
    //   const selectedOption = document.querySelector("[data-option-index='0'] .avis-option-value-item input:checked").value;

    //   console.log(selectedOption,"selectedOption");

    //   const mainSlider = document.querySelectorAll(".product__media-item");
    //   mainSlider.forEach(function(sliderItem){
    //     sliderItem.classList.add("hidden");
    //   });

    //   const subSlider = document.querySelectorAll(".product__media-subitem");
    //   subSlider.forEach(function(sliderItem){
    //     sliderItem.classList.add("hidden");
    //   });
      
    //   document.querySelectorAll(".product__media-item img[alt='"+selectedOption+"']").forEach(function(img){
    //     img.closest(".product__media-item").classList.remove("hidden");
    //   });
      
    //   document.querySelectorAll(".product__media-subitem img[alt='"+selectedOption+"']").forEach(function(img){
    //     img.closest(".product__media-subitem").classList.remove("hidden");
    //   });

    //   swiperInit();

    //   document.querySelectorAll("[data-option-index='0'] .avis-option-value-item input").forEach((opt)=>{
    //     opt.addEventListener("click",(e)=>{
    //       var val = opt.value;

    //       if(document.querySelectorAll(".product__media-item img[alt='"+val+"']").length != 0)
    //       {
    //         const mainSlider = document.querySelectorAll(".product__media-item");
    //         mainSlider.forEach(function(sliderItem){
    //           sliderItem.classList.add("hidden");
    //         });
      
    //         const subSlider = document.querySelectorAll(".product__media-subitem");
    //         subSlider.forEach(function(sliderItem){
    //           sliderItem.classList.add("hidden");
    //         });
            
    //         document.querySelectorAll(".product__media-item img[alt='"+val+"']").forEach(function(img){
    //           img.closest(".product__media-item").classList.remove("hidden");
    //         });
  
    //         document.querySelectorAll(".product__media-subitem img[alt='"+val+"']").forEach(function(img){
    //           img.closest(".product__media-subitem").classList.remove("hidden");
    //         });
      
    //         swiperInit();
    //       }
    //       else
    //       {
    //         const mainSlider = document.querySelectorAll(".product__media-item");
    //         mainSlider.forEach(function(sliderItem){
    //           sliderItem.classList.remove("hidden");
    //         });
      
    //         const subSlider = document.querySelectorAll(".product__media-subitem");
    //         subSlider.forEach(function(sliderItem){
    //           sliderItem.classList.remove("hidden");
    //         });
            
    //         swiperInit();
    //       }
          
    //     });
    //   });
      
      
    // },500);
    

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
        
	});

	//window.addEventListener("resize", function () {
	//	$(".product-section .js-media-list").each(function () {
	//		this.swiper.destroy();
	//	});
	//	$(".product-section .js-media-sublist").each(function () {
	//		this.swiper.destroy();
	//	});

	//	swiperInit();
	//});

	swiperInit();
})();
